/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AllowedDeniedIdAndLabel,
    AllowedDeniedIdAndLabelFromJSON,
    AllowedDeniedIdAndLabelFromJSONTyped,
    AllowedDeniedIdAndLabelToJSON,
    B2cUserAttribute,
    B2cUserAttributeFromJSON,
    B2cUserAttributeFromJSONTyped,
    B2cUserAttributeToJSON,
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    FieldPermissionIdAndLabel,
    FieldPermissionIdAndLabelFromJSON,
    FieldPermissionIdAndLabelFromJSONTyped,
    FieldPermissionIdAndLabelToJSON,
    SectionPermissionIdAndLabel,
    SectionPermissionIdAndLabelFromJSON,
    SectionPermissionIdAndLabelFromJSONTyped,
    SectionPermissionIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserPermissionsConfiguration
 */
export interface UserPermissionsConfiguration {
    /**
     * 
     * @type {Array<B2cUserAttribute>}
     * @memberof UserPermissionsConfiguration
     */
    readonly filterTypes?: Array<B2cUserAttribute> | null;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof UserPermissionsConfiguration
     */
    brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<SectionPermissionIdAndLabel>}
     * @memberof UserPermissionsConfiguration
     */
    readonly sectionPermissions?: Array<SectionPermissionIdAndLabel> | null;
    /**
     * 
     * @type {Array<FieldPermissionIdAndLabel>}
     * @memberof UserPermissionsConfiguration
     */
    readonly fieldPermissions?: Array<FieldPermissionIdAndLabel> | null;
    /**
     * 
     * @type {Array<AllowedDeniedIdAndLabel>}
     * @memberof UserPermissionsConfiguration
     */
    readonly allowedDeniedPermissions?: Array<AllowedDeniedIdAndLabel> | null;
}

export function UserPermissionsConfigurationFromJSON(json: any): UserPermissionsConfiguration {
    return UserPermissionsConfigurationFromJSONTyped(json, false);
}

export function UserPermissionsConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPermissionsConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filterTypes': !exists(json, 'filterTypes') ? undefined : (json['filterTypes'] === null ? null : (json['filterTypes'] as Array<any>).map(B2cUserAttributeFromJSON)),
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'sectionPermissions': !exists(json, 'sectionPermissions') ? undefined : (json['sectionPermissions'] === null ? null : (json['sectionPermissions'] as Array<any>).map(SectionPermissionIdAndLabelFromJSON)),
        'fieldPermissions': !exists(json, 'fieldPermissions') ? undefined : (json['fieldPermissions'] === null ? null : (json['fieldPermissions'] as Array<any>).map(FieldPermissionIdAndLabelFromJSON)),
        'allowedDeniedPermissions': !exists(json, 'allowedDeniedPermissions') ? undefined : (json['allowedDeniedPermissions'] === null ? null : (json['allowedDeniedPermissions'] as Array<any>).map(AllowedDeniedIdAndLabelFromJSON)),
    };
}

export function UserPermissionsConfigurationToJSON(value?: UserPermissionsConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandsAndMarkets': value.brandsAndMarkets === undefined ? undefined : (value.brandsAndMarkets === null ? null : (value.brandsAndMarkets as Array<any>).map(BrandAndMarketListItemToJSON)),
    };
}


